import CallToAction from "components/CallToAction"
import Wave from "public/assets/cta-banner.svg"
import { getStoryblokLink } from "utilities/getStoryblokLink"

export default function CTABanner({
  blok = {
    heading: "Ready to start feeling better?",
    cta_label: "Make an Appointment",
    cta_link: { href: "/make-an-appointment" },
  },
}) {
  return (
    <aside className="cta-banner-section">
      <Wave />
      <div className="bg-navy -mt-1">
        <div className="flex flex-col justify-center items-center lg:flex-row p-8 max-w-screen-xl mx-auto lg:justify-between lg:pt-0">
          <h2 className="text-white font-medium text-m2 lg:text-l2 uppercase text-center">{blok.heading}</h2>
          <CallToAction href={getStoryblokLink(blok.cta_link)} style="primary" className="w-max my-8">
            {blok.cta_label}
          </CallToAction>
        </div>
      </div>
    </aside>
  )
}
